module.exports = __webpack_public_path__ + "img/bandaoti_xiandaoyuan_suoluetu.d5d80ff0.png";